/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- REVENUE REPORT SECTION : STYLES --------------- ++++++++++ */
export default {
	revenuereportsection: {
		width: '100%',
		minHeight: '481px',
		height: '100%',
		background: 'white',
		'& .data': {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			width: '100%',
			// '& .linkcontrols': {
			// 	flexWrap: 'wrap',
			// 	justifyContent: 'center',
			// 	margin: pxToEm(24)
			// }
			'& .percent': {
				width: 'initial !important',
				padding: `${pxToEm(4)} ${pxToEm(8)}`
			},
            '& .cardtoggles': {
                maxHeight: pxToEm(120)
            }
		}
	},
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [`@media only screen and (max-width:${pxToEm(900)})`]: {
        revenuereportsection: {
            '& .cardtoggles': {
                maxHeight: 'initial !important',
                height: 'auto'
            }
        }
    }
};
